import { createRouter, createWebHistory } from 'vue-router'

const Home = () => import('./pages/home/index.vue')
const ProtocolView = () => import('./pages/protocol/index.vue')
const routes = [
  { path: '/', redirect: { name: 'home' } },
  { path: '/home', name: 'home', component: Home },
  { path: '/protocol/:target', name: 'protocol', component: ProtocolView }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
